import React, { ReactNode } from 'react'
import { Route } from 'react-router-dom'

import { NavGroup } from '~shared/models/NavigationModels'
import { isNavRouteCrude } from '~utils/isNavRouteCrude'

// improvement proposal -- this part needs refactoring -- as well as navigationConfig
export function buildNavRoutes(itemGroups: NavGroup[], crude: React.FC): ReactNode[] {
  return itemGroups.map((group) => {
    // let addCrudeRoute = false

    const Routes = group.items
      // .filter((item) => {
      //   if (isNavRouteCrude(item.route)) {
      //     addCrudeRoute = true
      //     return false
      //   }
      //
      //   return true
      // })
      .map((item, i) => <Route key={i} exact={item.route.exact} path={item.route.path} component={item.route.component} />)

    // if (addCrudeRoute) {
    //   Routes.push(<Route key='crudeRoute' path='/crude/' component={crude} />)
    // }

    return Routes
  })
}
